export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6812.a2a6c3f8.jpg";